(() => {
  const TITLE = 'Pago Contra Reembolso';
  const SUBTITLE = 'Envío gratis 24/48h';
  const normalized = (value) => (value || '').replace(/\s+/g, ' ').trim();
  function findFixedAncestor(el) {
    let node = el;
    for (let i = 0; node && node !== document.body && i < 12; i += 1, node = node.parentElement) {
      if (window.getComputedStyle(node).position === 'fixed') return node;
    }
    return null;
  }
  function markTextElement(root, text, className) {
    for (const el of root.querySelectorAll('*')) {
      if (normalized(el.textContent) === text) { el.classList.add(className); return el; }
    }
    return null;
  }
  function skinSticky() {
    for (const el of document.querySelectorAll('body *')) {
      const text = normalized(el.textContent);
      if (text !== TITLE && text !== SUBTITLE) continue;
      const sticky = findFixedAncestor(el);
      if (!sticky || sticky.classList.contains('lorenvia-releasit-sticky')) continue;
      const fullText = normalized(sticky.textContent);
      if (!fullText.includes(TITLE) || !fullText.includes(SUBTITLE)) continue;
      sticky.classList.add('lorenvia-releasit-sticky');
      markTextElement(sticky, TITLE, 'lorenvia-releasit-title');
      markTextElement(sticky, SUBTITLE, 'lorenvia-releasit-subtitle');
    }
  }
  let queued = false;
  const queueSkin = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; skinSticky(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queueSkin, { once: true });
  else queueSkin();
  new MutationObserver(queueSkin).observe(document.documentElement, { childList: true, subtree: true });
})();
